import { GameId } from '@common'
import cx from 'classnames'
import { useTranslations } from 'next-intl'

import { TimeLeft } from '@/utils/timer'

import { TimeRemaining } from '../../timeRemaining/TimeRemaining'
import { StoreTypography } from '../../typography/StoreTypography'

import styles from './bonusTimeRemaining.module.scss'

type BonusTimeRemainingProps = {
  remainingTime: TimeLeft
  gameSlug: GameId
}

export const BonusTimeRemaining = ({ remainingTime, gameSlug }: BonusTimeRemainingProps) => {
  const t = useTranslations()
  return (
    <div className={cx(styles.timerContainer, styles[gameSlug])}>
      <div className={styles.seasonTimer}>
        <StoreTypography
          tag="div"
          textSize={gameSlug === 'brawlstars' ? 'sm' : 'body'}
          style="plain"
          className={styles.timeLeftText}
        >
          {t('bonus_time_left')}
        </StoreTypography>
        <TimeRemaining
          className={styles.timeText}
          timeLeftText={remainingTime}
          textSize={gameSlug === 'brawlstars' ? 'sm' : undefined}
          type="secondary"
          textStyle="plain"
        />
      </div>
    </div>
  )
}
